module.exports = __webpack_public_path__ + "static/media/Sharp-5-inch-R-IGZO.6750cff0.png";